import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Configs from "services/ConfigHost"
import Auth from "auth"
import { thaiBath } from "helpers/ConvertFormat"
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsEmailHotAlertCheckUpdate } from "store/actions" 

import { ISOToDateFormat,ISOToDateYMDAndFullTime,CountISODateToNow } from "helpers/ConvertDate"

import * as Alert from "alertService"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit"
import FilterListIcon from "@material-ui/icons/FilterList"
import Radio from "@material-ui/core/Radio"; 
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AssignmentIcon from '@material-ui/icons/Assignment';
import TimerIcon from '@material-ui/icons/Timer';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel'; 

// core components  
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem" 
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader" 
import {Alert as AlertLabel, AlertTitle } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Select from "components/CustomSelects/Select.jsx"
import FormLabel from "@material-ui/core/FormLabel" 

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  }
}

const userData = Auth.getUserData()

function LabelAlert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataList:[],

      _id:null, 
      filePath:"",
      send_sms_date:null, 
      sms_expired_date:null, 
      originalFileName: "",
      description: "",
      rawCurrentData:{}, 
 
      selectedImportCondition:"c0",
      statusOpenDialogsAddStatus:false,
      dataListDealerTag:this.props.dataListDealerTag,

      cerrentDataListDealerTagId:"", 
      cerrentNote:"",

      rawListDataTag:[],
      countDateFristContectTime:"",
      countDateFristContectTimeFinish:"",
      countDateCloseCaseTimeFinish:""
    }
  } 
  componentWillUpdate(nextProps, nextState) {
    if(nextProps.currentData && nextProps.currentData !== nextState.rawCurrentData){ 
      this.setState({
        rawCurrentData: nextProps.currentData,
        _id: nextProps.currentData._id
      },()=>{
        this.countTimeFirstContactTime( nextProps.currentData.created_date_iso,()=>{ 
            this.loadDataListTag(nextProps.currentData.lead_id._id)
          }
        )
      })
    }else if(nextProps.currentData === null && this.state._id !== null){
      this.setState({
        rawCurrentData: {},
        _id:null, 
        countDateFristContectTime:null,
        countDateFristContectTimeFinish:null,
        rawListDataTag:[]
      },()=>{
        // this.props.id
        if(this.props.id != ":id"){
          var url = window.location.toString();
          window.location = url.replace( this.props.id, ':id');
        }
      })
    }
  }
  countTimeFirstContactTime = (isoDate,callback)=>{ 
    // const time_txt = CountISODateToNow(isoDate,this.state.countDateFristContectTimeFinish) 
    this.setState({
      countDateFristContectTime:isoDate
    },()=>{if(callback)callback()})
    
  }
  loadDataListTag = (lead_id)=>{
    Alert.Loading(true)
    var dataToSend = {
      lead_id :lead_id
    }
    APIPost( UrlServer.URL_POST_SEND_MAIL_HOT_ALERT_GET_STATUS,dataToSend,(datas)=>{ 
      this.setState({
        rawListDataTag:datas.datas,
      },()=>{
        var isBreak = false
        var countDateFristContectTimeFinish = null
        var isBreak2 = false
        var countDateCloseCaseTimeFinish = null
        if(datas.datas.length == 0 || !datas.datas)Alert.LoadingClose()

        datas.datas.map((data,index)=>{
          if(data.status_id.code != 1 && !isBreak){
            isBreak = true
            countDateFristContectTimeFinish = data.created_date_iso
          }
          if(data.status_id.code == 4 && !isBreak2){
            isBreak2 = true
            countDateCloseCaseTimeFinish = data.created_date_iso
          }
        })
        this.setState({
          countDateFristContectTimeFinish:countDateFristContectTimeFinish,
          countDateCloseCaseTimeFinish:countDateCloseCaseTimeFinish
        },()=>{  
          Alert.LoadingClose()
        }) 
      }) 
    })   
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  } 
   
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        no: (key + 1),
        first_name: CData.first_name,
        last_name: CData.last_name,
        tel: CData.tel,
        data_duplicate_count: CData.data_duplicate_count , 
      }
    })
  }
  callbackUploadedUrl = (filename,originalFileName)=>{ 
    this.setState({
      filePath:Configs.FILE_PATH +filename,
      originalFileName:originalFileName
    },()=>{
      Alert.LoadingClose()
    })
  } 
  handleChangeSelected = (event) => { 
    this.setState({ selectedImportCondition: event.target.value });
  }
  newUpload = () => {
    Alert.QuestionCallback("คุณต้องการอัพโหลดไฟล์ใหม่ใช่หรือไม่?","red",()=>{
      this.setState({ 
        _id : null,
        filePath:"",
        originalFileName:"",
        dataList:[]
       });
    })
  }
  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleSetState = (key,val) => {
    this.setState({[key]:val})
  }
  handleSetDialogOpen = () => {
    this.setState({statusOpenDialogsAddStatus:true})
  }
  handleSetDialogClose = () => {
    this.setState({statusOpenDialogsAddStatus:false})
  }
  handleAddStatus = () => {  
    this.setState({statusOpenDialogsAddStatus:false},()=>{
      if(this.state.cerrentDataListDealerTagId == ""){
        ErrorsCallback("ต้องการข้อมูล : เลือก Status ก่อน" )
        return
      }
      if(this.state.cerrentNote.length < 10){
        ErrorsCallback("ต้องการข้อมูล : กรุณาใส่ข้อความให้มากกว่า 10 ตัวอักษร" )
        return
      }
      Alert.Loading(true)
      var dataToSend = {
        lead_id :this.state.rawCurrentData.lead_id._id,
        question_id: this.state.rawCurrentData.question_id._id,
        send_mail_hot_alert_id : this.state._id,
        status_id :this.state.cerrentDataListDealerTagId, 
        note :this.state.cerrentNote,
      }
      APIPost( UrlServer.URL_POST_SEND_MAIL_HOT_ALERT_SAVE_SATUS,dataToSend,(datas)=>{ 
        var dataToSend2 = {
          lead_id :this.state.rawCurrentData.lead_id._id
        }
        APIPost( UrlServer.URL_POST_SEND_MAIL_HOT_ALERT_GET_STATUS,dataToSend2,(datas2)=>{ 
          this.setState({
            rawListDataTag:datas2.datas,
            cerrentNote:"",
            cerrentDataListDealerTagId:""
          },()=>{
            this.props.listsEmailHotAlertCheckUpdate(this.props.modeName);
          }) 
        })   
      })   
    })
    
  }
  renderListTag = (rawListDataTag)=>{
    return rawListDataTag.map((data,index)=>{
      var color_code = ""
      switch (data.status_id.code) {
        case 1:
          color_code = "txt-c-r"
          break;
        case 2:
          color_code = "txt-c-bu"
          break;
        case 3:
          color_code = "txt-c-dorg"
          break;
        case 4:
          color_code = "txt-c-g2"
          break;
        default:
          break;
      }
      return (
        <GridItem xs={12} key={"renderListTag"+index} >
            <span className={"span-23062020-2026 "+ color_code}>{data.status_id.description}</span>
            <i className="span-23062020-2029"> 
            {" "}( โดย {data.created_by_user.user_data_id.first_name+ " " + data.created_by_user.user_data_id.last_name} เมื่อ {ISOToDateYMDAndFullTime(data.created_date_iso)})
            </i><br/>
            <span>บันทึก : {data.note}</span><br/>
            <hr className={"hr-24062020-1723"}/>
        </GridItem>
      )
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <AssignmentIcon/>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  รายละเอียดลูกค้าที่เข้ารับบริการ
                </h4>
              </CardHeader>
              <CardBody> 
                  <GridContainer>
                      <GridItem xs={12} sm={6} className="GridItem-From"> 
                        <TextField
                          label="ชื่อ - สกุล"
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.lead_id &&
                              this.state.rawCurrentData.lead_id.first_name
                            )?
                            this.state.rawCurrentData.lead_id.first_name + " " + this.state.rawCurrentData.lead_id.last_name
                            :"-"
                          }
                          // defaultValue="Sarawoot Jaidee"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{  
                            className:"text-read"
                          }} 
                          variant="outlined" 
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} className="GridItem-From">
                        <TextField
                          label="เบอร์โทร"
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.lead_id &&
                              this.state.rawCurrentData.lead_id.tel
                            )?
                            this.state.rawCurrentData.lead_id.tel
                            :"-"
                          }
                          // defaultValue="0822206164"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{  
                            className:"text-read"
                          }}
                          variant="outlined" 
                        />
                      </GridItem>
                      <GridItem xs={12} sm={3} className="GridItem-From">
                        <TextField
                          label="วันที่ส่ง SMS"
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.lead_id &&
                              this.state.rawCurrentData.lead_id.last_sent_sms_date
                            )?
                            ISOToDateYMDAndFullTime(this.state.rawCurrentData.lead_id.last_sent_sms_date)
                            :"-"
                          }
                          // defaultValue="00/00/0000 23:59:59"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{   
                            className:"text-read"
                          }}
                          variant="outlined" 
                        />
                      </GridItem>
                      <GridItem xs={12} sm={3} className="GridItem-From">
                        <TextField
                          label="วันเวลาที่เริ่มตอบคำถาม"
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.question_id &&
                              this.state.rawCurrentData.question_id.created_date_iso
                            )?
                            ISOToDateYMDAndFullTime(this.state.rawCurrentData.question_id.created_date_iso)
                            :"-"
                          }
                          // defaultValue="00/00/0000 23:59:59"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{  
                            className:"text-read"
                          }}
                          variant="outlined" 
                        />
                      </GridItem>
                      <GridItem xs={12} sm={3} className="GridItem-From">
                        <TextField
                          label="วันเวลาที่ตอบคำถามเรียบร้อย"
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.question_id &&
                              this.state.rawCurrentData.question_id.finish_question_date
                            )?
                            ISOToDateYMDAndFullTime(this.state.rawCurrentData.question_id.finish_question_date)
                            :"-"
                          }
                          // defaultValue="00/00/0000 23:59:59"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{  
                            className:"text-read"
                          }}
                          variant="outlined" 
                        />
                      </GridItem>
                      <GridItem xs={12} sm={3} className="GridItem-From">
                        <TextField
                          label="วันเวลาที่ส่งเมลแจ้งเตือนครั้งแรก" 
                          value = {
                            (
                              this.state.rawCurrentData &&
                              this.state.rawCurrentData.created_date_iso 
                            )?
                            ISOToDateYMDAndFullTime(this.state.rawCurrentData.created_date_iso)
                            :"-"
                          }
                          // defaultValue="00/00/0000 23:59:59"
                          size="small"
                          fullWidth
                          disabled
                          InputProps={{  
                            className:"text-read"
                          }}
                          variant="outlined" 
                        />
                      </GridItem> 
                      <GridItem xs={12} sm={12} md={6}> 
                        <AlertLabel 
                          severity={(this.state.countDateFristContectTimeFinish)?"success":"warning"}
                          icon={(this.state.countDateFristContectTimeFinish)?<CheckCircleIcon/>:<TimerIcon/>}
                        >
                          <AlertTitle>นับวันที่ติดต่อครั้งแรก</AlertTitle>
                          { CountISODateToNow(this.state.countDateFristContectTime,this.state.countDateFristContectTimeFinish,true)}
                        </AlertLabel>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <AlertLabel 
                          severity={(this.state.countDateCloseCaseTimeFinish)?"success":"warning"}
                          icon={(this.state.countDateCloseCaseTimeFinish)?<CheckCircleIcon/>:<TimerIcon/>}
                        >
                          <AlertTitle>นับวันที่ Close Case</AlertTitle>
                          { CountISODateToNow(this.state.countDateFristContectTime,this.state.countDateCloseCaseTimeFinish,true)}
                        </AlertLabel> 
                      </GridItem> 
                  </GridContainer>   
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon> 
                <CardIcon color="info">
                  <SpeakerNotesIcon/>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  บันทึกสถานะ
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer >
                  {(this.state.rawListDataTag.length > 0)?
                    this.renderListTag(this.state.rawListDataTag)
                    :""
                  }
                  <GridItem xs={12}>
                    {
                      (
                        userData.user_type_code != 2 && 
                        // userData.user_type_code != 3 && 
                        userData.user_type_code != 7 && 
                        userData.user_type_code != 8 
                      )?
                      <Button
                        disabled={(!this.state._id || this.state._id == "")?true:false}
                        round
                        color="success"
                        className={classes.mt4}
                        onClick={ e => this.handleSetDialogOpen()}
                      >
                        <PlaylistAddIcon className={classes.icons} />
                        เพิ่มสถานะ
                      </Button>
                      :""
                    }
                   
                  </GridItem>
                </GridContainer>
                
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        {/* ==================== Dialog Add Status ==================== */}
        <Dialog open={this.state.statusOpenDialogsAddStatus} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">เพิ่มสถานะใหม่</DialogTitle>
          <DialogContent>
            <DialogContentText>
              เลือก Status และพิมพ์ข้อความได้ ไม่เกิน 2,000 ตัวอักษรต่อ Tag
            </DialogContentText>
            <GridContainer className="GridContainer-22062020-0610">
              <GridItem xs={12} className="GridItem-22062020-0613">
                <GridContainer >
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                      Status
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}> 
                    { 
                      (this.state.dataListDealerTag.length > 0) ?
                        <Select
                          value={(this.state.cerrentDataListDealerTagId)?this.state.cerrentDataListDealerTagId:""}
                          listData={this.state.dataListDealerTag}
                          onChange={this.handleChangeState("cerrentDataListDealerTagId")} 
                          variant="outlined"
                        />
                      : ""
                    }
                  </GridItem> 
                </GridContainer>
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Note"
                  multiline
                  rowsMax={12}
                  rows={6}    
                  fullWidth
                  value={this.state.cerrentNote}
                  onChange={e=>this.handleSetState("cerrentNote",e.target.value)}
                  variant="outlined"
                />
              </GridItem>
            </GridContainer> 
          </DialogContent>
          <DialogActions>
            <Button round onClick={ e => this.handleAddStatus()} color="success">
              <SaveIcon/> บันทึก
            </Button>{" "}
            <Button round onClick={ e => this.handleSetDialogClose() } >
              <CancelIcon/> ยกเลิก
            </Button>
            
          </DialogActions>
        </Dialog> 
      </div>
    )
  }
} 

function mapStateToProps({ listsEmailHotAlertCheck }) {
  return {
    listsEmailHotAlertCheck: listsEmailHotAlertCheck
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsEmailHotAlertCheckUpdate }
  )
)(ProjectCreateAndEditManagement)